module.exports = __webpack_public_path__ + "static/media/shoulder-triangle.c52b363d.png";